import { render } from "./Popitem.vue?vue&type=template&id=fc8a9a5a&scoped=true"
import script from "./Popitem.vue?vue&type=script&lang=js"
export * from "./Popitem.vue?vue&type=script&lang=js"

import "./Popitem.vue?vue&type=style&index=0&id=fc8a9a5a&lang=scss&scoped=true"

import exportComponent from "/Users/pmattern/Documents/3 - GIT/studio-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc8a9a5a"]])

export default __exports__